import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FcmState {
  token: string | null;
}

const initialState: FcmState = {
  token: null,
};

export const fcmSlice = createSlice({
  name: 'fcm',
  initialState,
  reducers: {
    setFcmToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    clearFcmToken: (state) => {
      state.token = null;
    },
  },
});

export const fcm = fcmSlice.actions;
export default fcmSlice.reducer;
